import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { Toaster } from 'sonner';
import App from './App';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';
import './styles/index.css';
import './yupExtensions';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <Router>
      {/* <React.StrictMode> */}
      <Toaster position="top-center" richColors closeButton />
      <App />
      {/* </React.StrictMode> */}
    </Router>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();